<footer class="footer footer-center p-4 bg-base-200 text-base-content">
  <div>
    <p>© {{ year }} Authorization System. All rights reserved.</p>
  </div>
</footer>
